// core/service-menus/service-menus.service.ts

import { Injectable } from "@angular/core";
import { ModuleFeatureAccessService } from "../moduleRoleAccess/moduleFeatureAccess/moduleFeatureAccess.service";
import { BehaviorSubject, Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ServiceMenus {

  private featureAccess: any = null;
  private role: string;

  constructor(private serviceModuleFeatureAccess: ModuleFeatureAccessService) {
    const data = localStorage.getItem("currentUser");
    const dataUser = data ? JSON.parse(data) : null;
    this.role = dataUser && dataUser.role ? dataUser.role : null;
  }

  /**
   * Ambil akses fitur dari API dan simpan ke dalam state lokal
   */
  loadFeatureAccess(featureName: string): Observable<any> {
    return this.serviceModuleFeatureAccess.getRouteMenuList(featureName).pipe(
      tap(res => {
        // console.log("✅ featureAccess loaded:", res.data);
        this.featureAccess = res.data;
      })
    );
  }

  /**
   * Cek apakah fitur tertentu disembunyikan berdasarkan role
   */
  checkHiddenFeature(type: string): boolean {
    // Don't hide access for those roles
    if (["administrator"].includes(this.role)) return false;

    if (!this.featureAccess) return true;

    const findRole = this.featureAccess.role_access && this.featureAccess.role_access.find((data) => data.role === this.role);
    if (!findRole) return true;

    return type === "add" ? !findRole.add :
           type === "edit" ? !findRole.edit :
           type === "view" ? !findRole.view :
           type === "delete" ? !findRole.delete :
           true;
  }
}
